import React, { createContext, useState, useContext } from "react";

const Context = createContext();

const ContextProvider = ({ children }) => {
  //configurator
  const [start, setStart] = useState(false);
  const [configuratorId, setConfiguratorId] = useState(null);
  const [configuratorTitle, setConfiguratorTitle] = useState("");
  const [configuratorSubheadline, setConfiguratorSubheadline] = useState("");
  const [configuratorDescription, setConfiguratorDescription] = useState("");
  const [navigationHeadline, setNavigationHeadline] = useState("");
  const [agbs, setAgbs] = useState("");
  const [minCalendar, setMinCalendar] = useState(0);
  const [maxCalendar, setMaxCalendar] = useState(0);
  const [vacation, setVacation] = useState(0);
  const [workingdays, setWorkingdays] = useState();
  const [exclusionDates, setExclusionDates] = useState([]);

  //steps
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(0);
  const [totalDynamicSteps, setTotalDynamicSteps] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [inputSummary, setInputSummary] = useState({});
  const [currentStepDescription, setCurrentStepDescription] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [successful, setSuccessful] = useState(true);
  const [isDateSelected, setIsDateSelected] = useState(false);

  const contextValue = {
    //configurator
    start,
    setStart,
    configuratorId,
    setConfiguratorId,
    configuratorTitle,
    setConfiguratorTitle,
    configuratorSubheadline,
    setConfiguratorSubheadline,
    configuratorDescription,
    setConfiguratorDescription,
    navigationHeadline,
    setNavigationHeadline,
    agbs,
    setAgbs,
    minCalendar,
    setMinCalendar,
    maxCalendar,
    setMaxCalendar,
    vacation,
    setVacation,
    workingdays,
    setWorkingdays,
    exclusionDates,
    setExclusionDates,

    //steps
    currentStep,
    setCurrentStep,
    totalSteps,
    setTotalSteps,
    totalDynamicSteps,
    setTotalDynamicSteps,
    progressPercentage,
    setProgressPercentage,
    inputSummary,
    setInputSummary,
    currentStepDescription,
    setCurrentStepDescription,
    submitted,
    setSubmitted,
    successful,
    setSuccessful,
    isDateSelected,
    setIsDateSelected,
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

const useGlobalContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useContext must be used within a ContextProvider");
  }
  return context;
};

export { ContextProvider, useGlobalContext };
